<style scoped>
.account-info ::v-deep .form-row {
    @apply max-w-lg;
}
@screen lg {
    .account-info ::v-deep .account-info-form-wrapper {
        @apply flex flex-row flex-wrap justify-between;
    }
    .account-info ::v-deep .form-row {
        @apply w-1/2 px-2;
    }
    .account-info ::v-deep .account-info-form-wrapper .form-row {
        @apply my-6;
    }
}
</style>

<template>
    <div class="account-info">
        <breadcrumb class="mt-4" :links="[{ msg: 'account.info' }]" />

        <div class="content-box-wrapper">
            <div class="flex flex-wrap items-center sm:ml-2 sm:mr-2 mb-8">
                <div class="text-2xl font-bold">
                    {{ $t('account.info') }}
                </div>
                <div class="ml-auto ">
                    <changePassword />
                </div>
            </div>
            <accountInfoForm @successSaved="successSaved" />
            <router-link
                tag="button"
                to="/logout"
                class="text-secondary underline hover:text-red focus:outline-none"
            >
                {{ '登出試吓啦' }}
            </router-link>
        </div>
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import changePassword from '@/components/changePassword.vue';
import accountInfoForm from '@/components/accountInfoForm.vue';

export default {
    components: {
        breadcrumb,
        changePassword,
        accountInfoForm
    },
    methods: {
        successSaved() {
            this.$store.commit('setShowConfirmPhoneNumber', true);
        }
    }
};
</script>
